import React from "react";
import Slider from 'react-slick';
import styled, {css} from 'styled-components';

import {s3image_url_convertor} from '../../Lib/Utils/converter';

//component
import SwiperDot from "./SwiperDot";
import { CloudfrontBackground } from "../CloudfrontAsset";



function ImageSwiper({ imageUrlList, customStyle }) {

    const Wrapper = styled.div`
        width: 100%;
        height: auto;
        display: block;
    `

    const SwiperItem = styled(CloudfrontBackground)`
        width: 100%;
        height: 256px;
        

        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
       
    `

    const Dot = styled.div`
        width: 6px;
        height: 6px;
        background-color: red;
        border-radius: 50%;
        background-color: #ddd;
    `

    const DotWrapper = styled.div`
        bottom: -16px;
        position: relative;
        height: 38px
        
        ul {
            padding: 0;
        }
        
        li {
            width: 6px;
            height: 6px;
            margin: 0;
            
            &.slick-active ${Dot} {
                background-color: #aaaaaa;
            } 
        }
        
        li:not(:first-child) {
            margin-left: 8px;
        }
    `

    const setting = {
        dots: true,
        appendDots: dots => (
            <DotWrapper>
                <ul style={{ margin: "0px" }}> {dots} </ul>
            </DotWrapper>
        ),
        customPaging: function(i) {
            return (
                <Dot/>
            );
        },
    }

    const renderSliderItem = () => {
        return (imageUrlList || []).map((item, index) => {
            return (
                <SwiperItem
                    imageUrl={s3image_url_convertor(item, 'original')}
                    logContext={{ component: 'ImageSwiper', imageIndex: index }}
                    key={index}
                />
            )
        })
    }
    console.log("==")
    console.log(imageUrlList)

    return (
        <Wrapper style={customStyle}>
            <Slider {...setting}>
                {renderSliderItem()}
            </Slider>
        </Wrapper>
    )
}

export default ImageSwiper;
/*

class ImageSwiper extends React.Component {
    constructor() {
        super();
        this.state = {
            activeIndex: 0,
            swipeContents: [],
        };
    }

    componentWillMount() {
        this.setState({
            imageUrlList: this.props.imageUrlList
        }, () => {
            this.setState({
                swipeContents: this.swipeContents,
            })
        });
    }

    render() {
        let renderSwiperContents = this.state.imageUrlList.map((item, index) => {
            return (
              <div className={style.swipe} style={{
                  backgroundImage: 'url(' + item + ')',
                  backgroundSize: '100%',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundColor: '#ccc'
              }}>
                  Swiper {index + 1}
              </div>)
        });

        return (
            <div className={style.container}>
                <div className={style.swipe}>
                    <ReactSwipe
                        ref={ref => {
                            this.swiper = ref;
                        }}
                        swipeOptions={{
                            continuous: true,
                            callback: (index, element) => {
                            },
                            transitionEnd: (index, element) => {
                                this.setState(
                                    {
                                        activeIndex: index
                                    },
                                    () => {
                                        this.swiper.slide(index);
                                    }
                                );
                            }
                        }}
                    >
                        {renderSwiperContents}
                    </ReactSwipe>
                </div>
                <SwiperDot
                    activeIndex={this.state.activeIndex}
                    swipeContents={renderSwiperContents}
                />
            </div>
        );
    }
}

export default ImageSwiper;
*/
